module.exports = __webpack_public_path__ + "img/click_time.6ae5503e.png";